import React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';
import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

import { useAuthStore } from 'connect/web/src/stores/auth-store';
import { SearchType, useSearchStore } from 'connect/web/src/stores/search-store';

import NavButton from '../nav-button';
import NavAuthenticted from './authenticated';
import NavContainer from './container';

interface IProps {}

const Nav = observer(
  withDisplayName<IProps>(() => {
    const { isAuthenticated } = useAuthStore();

    const searchStore = useSearchStore();
    const { hasClasses, hasAppointments } = searchStore;

    const packagesAvailable = useComputed((): boolean => {
      return searchStore.packages.some((pk) => pk.online);
    }, [searchStore]);

    const onClickAppointment = useAction((): void => {
      searchStore.locationId = 'All';
      searchStore.mode = SearchType.Appointment;
    }, [searchStore]);

    const onClickClass = useAction((): void => {
      searchStore.locationId = 'All';
      searchStore.mode = SearchType.Class;
    }, [searchStore]);

    const authenticatedButtons = isAuthenticated ? (
      <NavAuthenticted />
    ) : (
      <NavButton tabIndex={9} text="Log In / Register" path="/login" />
    );

    return (
      <NavContainer>
        {hasAppointments && (
          <NavButton
            tabIndex={2}
            text="Book an Appointment"
            path="/book"
            onClick={onClickAppointment}
          />
        )}
        {hasClasses && (
          <NavButton tabIndex={3} text="Explore Classes" path="/book" onClick={onClickClass} />
        )}
        {packagesAvailable && <NavButton tabIndex={4} text="Packages" path="/packages" />}
        {authenticatedButtons}
      </NavContainer>
    );
  }, 'Nav')
);

export default Nav;
